import { useQuery } from '@tanstack/react-query'
import instance from '../api'
import { useAuthContext } from '../../context/auth/auth'
import { Transaction } from '../../interfaces/transaction'

// Confirmed: `PaymentViewSet.get_queryset` returns every Payment to a super
// administrator and only the caller's own otherwise, so this one endpoint
// serves both this screen and useSubscriptionInvoices. No pagination class is
// configured project-wide, so the payload is a bare array rather than
// `{ count, results }`.
const TRANSACTIONS_ENDPOINT = '/payment/payments/'

const getTransactions = async (token: string): Promise<Transaction[]> => {
  const response = await instance.get(TRANSACTIONS_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data.data
}

const useTransactions = () => {
  const { token } = useAuthContext()

  return useQuery({
    queryKey: ['transactions'],
    queryFn: () => getTransactions(token!),
  })
}

export default useTransactions
